// 后台业务操作：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。
// 管理流程
export const flows = Object.freeze({
  "adminFlows.loading": "載入中...",
  "adminFlows.updating": "修改中...",
  "adminFlows.publishing": "發佈中...",
  "adminFlows.recognizedAndFilledCountProducts": "已識別並填充 {count} 條商品",
  "adminFlows.noProductDetailsTheOrderCannotBePlaced":
    "商品明細為空，暫時無法下單",
  "adminFlows.someProductSpecificationsAreNoLongerAvailableGoBackAndSelectAgain":
    "部分商品規格已失效，請返回重新選擇",
  "adminFlows.completeTheProductInformation": "請填寫完整的商品資料！",
  "adminFlows.enterTheBrand": "請填寫品牌",
  "adminFlows.enterAPartNumber": "請填寫料號",
  "adminFlows.enterAPriceGreaterThanZero": "請填寫大於0的價格",
  "adminFlows.enterTheQuantity": "請填寫數量",
  "adminFlows.enterAQuantityGreaterThanZero": "請填寫大於0的數量",
  "adminFlows.membershipLevels": "會員等級列表",
  "adminFlows.levelName": "等級名稱",
  "adminFlows.requiredPoints": "所需積分",
  "adminFlows.tradeDiscount": "交易折扣",
  "adminFlows.members": "會員人數",
  "adminFlows.benefits": "權益説明",
  "adminFlows.status": "狀態",
  "adminFlows.enabled": "啓用",
  "adminFlows.disabled": "停用",
  "adminFlows.actions": "操作",
  "adminFlows.edit": "編輯",
  "adminFlows.delete": "刪除",
  "adminFlows.levelApplications": "等級申請記錄",
  "adminFlows.assignLevel": "指定等級",
  "adminFlows.applicant": "申請人",
  "adminFlows.currentLevel": "當前等級",
  "adminFlows.requestedLevel": "申請等級",
  "adminFlows.applicationReason": "申請理由",
  "adminFlows.appliedAt": "申請時間",
  "adminFlows.approve": "通過",
  "adminFlows.reject": "拒絕",
  "adminFlows.membershipBenefits": "等級權益管理",
  "adminFlows.requiredPointsLabel": "所需積分：",
  "adminFlows.tradeDiscountLabel": "交易折扣：",
  "adminFlows.memberCountLabel": "會員人數：",
  "adminFlows.benefitsLabel": "權益説明：",
  "adminFlows.assignMembershipLevel": "指定會員等級",
  "adminFlows.selectMember": "選擇成員",
  "adminFlows.selectASalesperson": "請選擇業務員",
  "adminFlows.targetLevel": "目標等級",
  "adminFlows.selectALevel": "請選擇等級",
  "adminFlows.reason": "設置理由",
  "adminFlows.enterAReason": "請輸入設置理由",
  "adminFlows.cancel": "取消",
  "adminFlows.confirmAssignment": "確認指定",
  "adminFlows.editMembershipLevel": "編輯會員等級",
  "adminFlows.enterRequiredPoints": "請輸入所需積分",
  "adminFlows.selectADiscount": "請選擇折扣",
  "adminFlows.enterBenefitDetails": "請輸入權益説明",
  "adminFlows.saveChanges": "儲存修改",
  "adminFlows.unableToLoadMembershipLevelsPleaseTryAgain":
    "會員等級數據載入失敗，請稍後重試",
  "adminFlows.approved": "已通過",
  "adminFlows.rejected": "已拒絕",
  "adminFlows.pendingReview": "審核中",
  "adminFlows.selectAMemberAndTargetLevel": "請選擇成員和目標等級",
  "adminFlows.membershipLevelAssigned": "已成功指定會員等級",
  "adminFlows.completeTheRequiredInformation": "請填寫完整的資料",
  "adminFlows.membershipLevelUpdated": "等級修改成功",
  "adminFlows.notice": "提示",
  "adminFlows.confirm": "確定",
  "adminFlows.deletedSuccessfully": "刪除成功",
  "adminFlows.levelApplicationApproved": "已通過等級申請",
  "adminFlows.levelApplicationRejected": "已拒絕該申請",
  "adminFlows.noDiscount": "無折扣",
  "adminFlows.discount99": "99折",
  "adminFlows.discount98": "98折",
  "adminFlows.discount97": "97折",
  "adminFlows.discount95": "95折",
  "adminFlows.discount93": "93折",
  "adminFlows.discount9": "9折",
  "adminFlows.discount88": "88折",
  "adminFlows.discount85": "85折",
  "adminFlows.membershipIdentities": "會員身份列表",
  "adminFlows.identityName": "身份名稱",
  "adminFlows.participantCount": "人數",
  "adminFlows.defaultLevel": "預設等級",
  "adminFlows.maximumLevel": "最高等級",
  "adminFlows.permissions": "權限説明",
  "adminFlows.createdAt": "創建時間",
  "adminFlows.salespersonManagement": "業務員管理",
  "adminFlows.account": "賬號",
  "adminFlows.name": "姓名",
  "adminFlows.company": "所屬公司",
  "adminFlows.mobileNumber": "流動電話號碼",
  "adminFlows.membershipLevel": "會員等級",
  "adminFlows.active": "正常",
  "adminFlows.frozen": "凍結",
  "adminFlows.unfreeze": "解凍",
  "adminFlows.customerManagement": "客戶管理",
  "adminFlows.contact": "聯絡人",
  "adminFlows.companyName": "公司名稱",
  "adminFlows.transactions": "交易次數",
  "adminFlows.supplierManagement": "供應商管理",
  "adminFlows.supplierName": "供應商名稱",
  "adminFlows.supplyType": "供應類型",
  "adminFlows.yearsOfCooperation": "合作年限",
  "adminFlows.partnerManagement": "合作伙伴管理",
  "adminFlows.partnerName": "合作方名稱",
  "adminFlows.cooperationType": "合作類型",
  "adminFlows.enterAContactName": "請輸入聯絡人",
  "adminFlows.enterACompanyName": "請輸入公司名稱",
  "adminFlows.enterAMobileNumber": "請輸入流動電話號碼",
  "adminFlows.selectAMembershipLevel": "請選擇會員等級",
  "adminFlows.enterASupplyType": "請輸入供應類型",
  "adminFlows.enterACooperationType": "請輸入合作類型",
  "adminFlows.editIdentity": "編輯身份",
  "adminFlows.selectADefaultLevel": "請選擇預設等級",
  "adminFlows.selectAMaximumLevel": "請選擇最高等級",
  "adminFlows.salesperson": "業務員",
  "adminFlows.customer": "客戶",
  "adminFlows.supplier": "供應商",
  "adminFlows.partner": "合作伙伴",
  "adminFlows.member": "成員",
  "adminFlows.unableToLoadMembershipIdentitiesPleaseTryAgain":
    "會員身份數據載入失敗，請稍後重試",
  "adminFlows.updatedSuccessfully": "修改成功",
  "adminFlows.deleteThisIdentity": "確定要刪除該身份嗎？",
  "adminFlows.enterTheContactNameAndMobileNumber": "請填寫聯絡人和流動電話號碼",
  "adminFlows.myCustomers": "我的客戶",
  "adminFlows.customerId": "客戶ID",
  "adminFlows.customerName": "客戶名稱",
  "adminFlows.noCustomersYet": "暫無客戶資料",
  "adminFlows.findCustomers": "獲取客戶",
  "adminFlows.myOrders": "我的訂單",
  "adminFlows.period": "期數",
  "adminFlows.brand": "品牌",
  "adminFlows.partNumber": "料號",
  "adminFlows.type": "類型",
  "adminFlows.bidPrice": "競標價格",
  "adminFlows.bidQuantity": "競標數量",
  "adminFlows.bidTime": "競標時間",
  "adminFlows.pcs": "件",
  "adminFlows.noOrdersYet": "暫無訂單記錄",
  "adminFlows.viewBidding": "查看競標",
  "adminFlows.unableToLoadCustomers": "客戶列表載入失敗",
  "adminFlows.biddingOpen": "競標中",
  "adminFlows.pendingOpening": "待開標",
  "adminFlows.won": "已中標",
  "adminFlows.notWon": "未中標",
  "adminFlows.biddingClosed": "已截標",
  "adminFlows.opened": "已開標",
  "adminFlows.back": "返回",
  "adminFlows.productInformation": "產品資料",
  "adminFlows.aiRecognition": "智能識別",
  "adminFlows.enterTextOrPasteAProductImage": "請輸入文本或粘貼產品圖片內容",
  "adminFlows.recognitionImagePreview": "識別圖片預覽",
  "adminFlows.imageRecognition": "圖片識別",
  "adminFlows.speechRecognition": "語音識別",
  "adminFlows.recognizeAndFill": "識別並填充",
  "adminFlows.orderType": "訂單類型",
  "adminFlows.privateOrder": "專屬訂單",
  "adminFlows.sendToASpecificBuyerEnterTheBuyerPhoneNumber":
    "指定買家接收訂單，選擇後需要填寫買家電話",
  "adminFlows.buyerPhone": "買家電話",
  "adminFlows.enterTheBuyerPhoneNumber": "請填寫買家電話",
  "adminFlows.publicOrder": "公開訂單",
  "adminFlows.publishPubliclyWithoutASpecificBuyerPhoneNumber":
    "發佈為公開訂單，無需指定買家電話",
  "adminFlows.productCategory": "產品分類",
  "adminFlows.selectAProductCategory": "請選擇產品分類",
  "adminFlows.uploadImages": "上傳圖片",
  "adminFlows.dragToUploadOrReorderDoubleClickToPreview":
    "（支持拖拽上傳、拖拽排序，雙擊放大預覽）",
  "adminFlows.uploadProductImages": "上傳產品圖片",
  "adminFlows.productName": "產品名稱",
  "adminFlows.enterAProductName": "請填寫產品名稱",
  "adminFlows.enterABrandName": "請填寫品牌名稱",
  "adminFlows.selectBrand": "選擇品牌",
  "adminFlows.unitPrice": "單價",
  "adminFlows.enterAUnitPrice": "請輸入單價",
  "adminFlows.approx": "約",
  "adminFlows.quantityUnit": "數量/單位",
  "adminFlows.enterQuantity": "請輸入數量",
  "adminFlows.enterUnit": "填寫單位",
  "adminFlows.deliveryAddress": "交貨地址",
  "adminFlows.enterADeliveryAddress": "請填寫交貨地址",
  "adminFlows.dateCodeDc": "批次(DC)",
  "adminFlows.enterADateCode": "請填寫批次",
  "adminFlows.goodsCondition": "貨物情況",
  "adminFlows.multipleSelection": "（多選）",
  "adminFlows.noCategoryAttributesSelectASubcategory":
    "暫無分類屬性，請選擇二級分類",
  "adminFlows.additionalInformation": "補充資料",
  "adminFlows.expand": "展開",
  "adminFlows.datasheet": "規格書",
  "adminFlows.uploadDatasheet": "上傳規格書",
  "adminFlows.manufacturer": "廠家",
  "adminFlows.enterAManufacturer": "請填寫廠家",
  "adminFlows.weight": "重量",
  "adminFlows.enterWeight": "請填寫重量",
  "adminFlows.g": "克",
  "adminFlows.dimensions": "尺寸",
  "adminFlows.length": "長度",
  "adminFlows.mm": "毫米",
  "adminFlows.width": "寬度",
  "adminFlows.height": "高度",
  "adminFlows.alternativeProducts": "替代產品",
  "adminFlows.addAlternativeProduct": "添加替代產品",
  "adminFlows.applications": "應用領域",
  "adminFlows.separateWithSpacesOrCommasPressEnterToConfirm":
    "用空格或逗號分開，按回車確認",
  "adminFlows.minimumOrderQuantity": "起訂量",
  "adminFlows.enterMinimumOrderQuantity": "請填寫起訂量",
  "adminFlows.validUntil": "有效期",
  "adminFlows.selectValidityDate": "請選擇有效期",
  "adminFlows.leadTime": "交貨天數",
  "adminFlows.enterEstimatedLeadTime": "請填寫預計交貨天數",
  "adminFlows.businessDays": "工作日",
  "adminFlows.ownerCompany": "貨主公司",
  "adminFlows.enterTheGoodsOwnerCompanyName": "請填寫貨主公司名稱",
  "adminFlows.remarks": "備註",
  "adminFlows.enterProductRemarks": "請填寫產品資料備註",
  "adminFlows.collapse": "收起",
  "adminFlows.purchaseRequirements": "需求資料",
  "adminFlows.productPrice": "商品價格",
  "adminFlows.enterProductPrice": "請填寫商品價格",
  "adminFlows.quantity": "數量",
  "adminFlows.enterPurchaseQuantity": "請填寫購買數量",
  "adminFlows.buyerInformation": "買家資料",
  "adminFlows.companyNameRequired": "請填寫公司名稱",
  "adminFlows.taxId": "税號",
  "adminFlows.enterATaxId": "請填寫税號",
  "adminFlows.contactNameRequired": "請填寫聯絡人",
  "adminFlows.contactDetails": "聯絡方式",
  "adminFlows.enterContactDetails": "請填寫聯絡方式",
  "adminFlows.uploadOrderInformation": "上傳訂單資料",
  "adminFlows.orderInformation": "訂單資料",
  "adminFlows.saveDraft": "暫存",
  "adminFlows.searchByCategoryName": "請輸入分類名稱搜索",
  "adminFlows.selectDate": "選擇年月日",
  "adminFlows.selectADate": "請選擇日期",
  "adminFlows.publishFeaturedProduct": "精選發佈頁面",
  "adminFlows.useAvailableDetailsToPublishAProductQuickly":
    "選填已有資料，快速發佈商品",
  "adminFlows.confirmPublication": "確認發佈",
  "adminFlows.quickOrder": "快捷下單",
  "adminFlows.editFeaturedProduct": "編輯精選商品",
  "adminFlows.updateProductDetailsAndSubmitForReview": "修改商品資料並提交審核",
  "adminFlows.confirmChanges": "確認修改",
  "adminFlows.required": "必填項",
  "adminFlows.enterAValidNumber": "請填寫有效的數字",
  "adminFlows.enterAPositiveInteger": "請輸入正整數",
  "adminFlows.cannotBeEmpty": "不能為空",
  "adminFlows.selectGoodsCondition": "請選擇貨物情況",
  "adminFlows.datasheetAttachment": "規格書附件",
  "adminFlows.pleaseSignInFirst": "請先登入",
  "adminFlows.onlyJpgPngAndWebpImagesAreSupported":
    "只支持 JPG、PNG、WEBP 圖片",
  "adminFlows.imageMustNotExceed10Mb": "圖片不能超過 10MB",
  "adminFlows.speechRecognitionIsNotSupportedByThisBrowser":
    "當前瀏覽器不支持語音識別",
  "adminFlows.speechRecognitionFailedPleaseTryAgain": "語音識別失敗，請重試",
  "adminFlows.enterTextOrSelectAnImageFirst": "請先輸入文字或選擇圖片",
  "adminFlows.noUsableProductInformationRecognized": "未識別到可填充的產品資料",
  "adminFlows.recognizedAndFilledSuccessfully": "識別並填充成功",
  "adminFlows.recognitionFailedPleaseTryAgain": "識別失敗，請重試",
  "adminFlows.unableToLoadProductInformation": "商品資料載入失敗",
  "adminFlows.unableToLoadProductInformationPleaseTryAgain":
    "商品資料載入失敗，請稍後重試",
  "adminFlows.quickOrderCreated": "快捷下單成功！",
  "adminFlows.draftSaved": "內容暫存成功！",
  "adminFlows.selectAnOrderType": "請選擇訂單類型",
  "adminFlows.selectAValidOrderType": "請選擇有效的訂單類型",
  "adminFlows.publishedSuccessfully": "發佈成功",
  "adminFlows.completeAllInformation": "請填寫完整資料！",
  "adminFlows.selectASubcategory": "請選擇二級分類",
  "adminFlows.enterAnAlternativeBrand": "請填寫替代品牌",
  "adminFlows.enterAnAlternativePartNumber": "請填寫替代料號",
  "adminFlows.suggestedTags": "常用標籤：",
  "adminFlows.computers": "電腦",
  "adminFlows.mobilePhones": "手機",
  "adminFlows.automotive": "汽車",
  "adminFlows.iot": "物聯網",
  "adminFlows.networking": "網絡",
  "adminFlows.hongKongChina": "中國香港",
  "adminFlows.mainlandChina": "中國大陸",
  "adminFlows.newAndOriginal": "全新原裝",
  "adminFlows.original": "原裝",
  "adminFlows.salvaged": "拆機",
  "adminFlows.newLoosePackaging": "散新",
  "adminFlows.deleteMembershipLevelConfirmation": "確定要刪除 {level} 等級嗎？",
  "adminFlows.approveLevelApplicationConfirmation":
    "確定通過 {name} 的等級申請？",
  "adminFlows.rejectLevelApplicationConfirmation":
    "確定拒絕 {name} 的等級申請？",
  "adminFlows.levelPointsOption": "{level} (積分>={points})",
  "adminFlows.editType": "編輯{type}",
  "adminFlows.entityActionConfirmation": "確定要{action}該{type}嗎？",
  "adminFlows.actionCompleted": "{action}成功",
  "adminFlows.deleteEntityConfirmation": "確定要刪除該{type}嗎？",
  "adminFlows.enterField": "請輸入{field}",
  "adminFlows.certificateOfOriginCount": "原產地證明{count}",
  "adminFlows.recognizedCountProductsOnlyTheFirstIsFilled":
    "識別到 {count} 條產品，當前僅填充第一條",
  "adminFlows.upToMaxTagsAreAllowed": "最多隻能添加{max}個標籤",
});

// 数据看板：只维护显示文字，不改变原始工作表、筛选值或业务数据。
export const reportDashboard = Object.freeze({
  "reportDashboard.title": "業務數據看板",
  "reportDashboard.summaryHint":
    "僅統計交易完成訂單 · 按訂單建立日期 · 人民幣待分類且不重複計入",
  "reportDashboard.dataSource": "數據來源",
  "reportDashboard.remoteSource": "後端查詢",
  "reportDashboard.reportType": "報表類型",
  "reportDashboard.salesDashboard": "銷售額看板",
  "reportDashboard.purchaseDashboard": "採購成本看板",
  "reportDashboard.exportFiltered": "匯出篩選結果",
  "reportDashboard.viewDenied": "目前賬戶沒有此類數據看板權限",
  "reportDashboard.filters": "看板篩選",
  "reportDashboard.allCompanies": "全部本方公司",
  "reportDashboard.startDate": "訂單建立開始日期",
  "reportDashboard.endDate": "結束日期",
  "reportDashboard.allCustomers": "全部客戶",
  "reportDashboard.allSuppliers": "全部供應商",
  "reportDashboard.allModels": "全部料號",
  "reportDashboard.businessSource": "業務分類",
  "reportDashboard.allSources": "全部業務",
  "reportDashboard.cnySource": "人民幣業務／待分類",
  "reportDashboard.usdSource": "美元業務",
  "reportDashboard.allCurrencies": "全部貨幣",
  "reportDashboard.cnyCurrency": "人民幣 CNY",
  "reportDashboard.usdCurrency": "美元 USD",
  "reportDashboard.unitPlaceholder": "數量單位（選填）",
  "reportDashboard.keywordPlaceholder": "訂單號／料號／商品名稱",
  "reportDashboard.search": "查詢",
  "reportDashboard.reset": "重設",
  "reportDashboard.facetsTruncated":
    "篩選項目僅顯示首100項，請收窄條件後查詢。",
  "reportDashboard.readFailureHint":
    "查詢失敗，不會改用Excel或示範數據。下方如有內容，為上一次成功查詢結果。",
  "reportDashboard.reading": "正在載入…",
  "reportDashboard.filtersChanged":
    "篩選條件已更改，請按查詢。目前仍為上一次結果。",
  "reportDashboard.generatedAt": "概覽查詢時間 {time}（各次查詢時間獨立）",
  "reportDashboard.notRead": "尚未載入",
  "reportDashboard.overview": "業務概覽",
  "reportDashboard.salesDetailCount": "銷售明細筆數",
  "reportDashboard.purchaseDetailCount": "採購明細筆數",
  "reportDashboard.customerCount": "合作客戶主體數",
  "reportDashboard.supplierCount": "合作供應商主體數",
  "reportDashboard.quantityTotal": "商品總數量 · {unit}",
  "reportDashboard.salesAmount": "銷售額",
  "reportDashboard.purchaseCost": "採購成本",
  "reportDashboard.missingDataWarning":
    "部分明細缺少金額或客戶主體，請核對原訂單；缺漏值不會補作實際金額。",
  "reportDashboard.monthlyTrend": "每月商品數量趨勢",
  "reportDashboard.selectUnit": "選擇單位",
  "reportDashboard.trendAccessibleLabel":
    "每月數量趨勢，單位{unit}，貨幣{currency}",
  "reportDashboard.noTrend": "目前單位及貨幣暫無趨勢數據",
  "reportDashboard.trendHint":
    "趨勢僅顯示相同單位及貨幣；金額不會在瀏覽器重新匯總。",
  "reportDashboard.customerRanking": "客戶金額排名",
  "reportDashboard.supplierRanking": "供應商金額排名",
  "reportDashboard.unknownCounterparty": "未標示主體",
  "reportDashboard.noRanking": "暫無排名",
  "reportDashboard.completedDetails": "成功訂單明細",
  "reportDashboard.paginationSummary":
    "共 {total} 筆 · 目前第 {page} 頁 · 查詢時間 {time}",
  "reportDashboard.noRecords": "目前條件下沒有交易完成訂單",
  "reportDashboard.orderNumber": "訂單號",
  "reportDashboard.createdAt": "訂單建立日期",
  "reportDashboard.ownCompany": "本方公司",
  "reportDashboard.customer": "客戶",
  "reportDashboard.supplier": "供應商",
  "reportDashboard.partNumber": "料號",
  "reportDashboard.goodsName": "商品名稱",
  "reportDashboard.quantity": "商品數量",
  "reportDashboard.amount": "成交金額",
  "reportDashboard.counterpartyId": "客戶／供應商ID",
  "reportDashboard.counterparty": "客戶／供應商",
  "reportDashboard.quantityUnit": "數量單位",
  "reportDashboard.currency": "貨幣",
  "reportDashboard.exactAmount": "成交金額（精確十進制）",
  "reportDashboard.salesSheet": "銷售明細",
  "reportDashboard.purchaseSheet": "採購明細",
  "reportDashboard.exportFilename": "成功訂單看板明細.xlsx",
  "reportDashboard.unitPieces": "件",
  "reportDashboard.unitTrays": "盤",
  "reportDashboard.unitUnknown": "未標示單位",
  "reportDashboard.readFailed": "看板載入失敗",
  "reportDashboard.recordsFailed": "明細載入失敗",
  "reportDashboard.exportFailed": "看板匯出失敗，請重試",
  "reportDashboard.companiesFailed": "公司清單載入失敗",
  "reportDashboard.companiesInvalid": "公司清單回傳格式不正確",
  "reportDashboard.workbookInvalid": "報表介面未回傳有效的Excel檔案",
  "reportDashboard.workbookEmpty": "報表介面回傳了空檔案",
  "reportDashboard.responseInvalid": "看板數據回傳格式錯誤",
  "reportDashboard.invalidPart": "無效的看板讀取類型",
  "reportDashboard.exportInvalid": "看板匯出未回傳有效檔案",
  "reportDashboard.errorLoginRequired": "請先登入",
  "reportDashboard.errorNoAccess": "目前賬戶沒有數據看板權限",
  "reportDashboard.errorInvalidReportType": "報表類型錯誤",
  "reportDashboard.errorReportTypeForbidden": "無權查看此類報表",
  "reportDashboard.errorNoCompanyScope": "尚未設定可查看的公司範圍",
  "reportDashboard.errorCompanyForbidden": "公司不在授權範圍內",
  "reportDashboard.errorDateOrderInvalid": "開始日期不可晚於結束日期",
  "reportDashboard.errorPageInvalid": "分頁參數超出範圍",
  "reportDashboard.errorCurrencyInvalid": "貨幣無效",
  "reportDashboard.errorSourceInvalid": "業務分類無效",
  "reportDashboard.errorSourceCurrencyConflict": "業務分類與貨幣不符",
  "reportDashboard.errorCustomerInvalid": "客戶主體無效",
  "reportDashboard.errorDateRangeInvalid": "日期超出資料庫支援範圍",
  "reportDashboard.errorDateFormatInvalid": "日期必須為有效的yyyy-MM-dd格式",
  "reportDashboard.errorFilterTooLong": "篩選條件過長",
  "reportDashboard.errorTrendLimitExceeded":
    "趨勢範圍過大，請收窄時間或單位範圍",
  "reportDashboard.errorExportLimitExceeded": "匯出超過10000筆，請收窄篩選範圍",
  "reportDashboard.errorUnavailable": "看板數據暫時無法使用，請重試",
  "reportDashboard.errorInvalidArgument": "看板請求參數無效，請檢查後重試",
  "reportDashboard.errorFailed": "看板操作失敗，請稍後重試",
  "reportDashboard.viewLoadingData": "數據載入中",
  "reportDashboard.viewDataLoaded": "數據已載入",
  "reportDashboard.viewValue0ItemsToCheck": "{value0} 項待核對",
  "reportDashboard.viewServerReports": "後端報表",
  "reportDashboard.viewSelectReport": "查看報表",
  "reportDashboard.viewAddData": "新增數據",
  "reportDashboard.viewUploadExcel": "上載Excel",
  "reportDashboard.viewRefreshData": "重新整理數據",
  "reportDashboard.viewLoadSourceWorksheetsForChecking":
    "按需要讀取原工作表核對",
  "reportDashboard.viewExportCurrentData": "匯出目前數據",
  "reportDashboard.viewCouldNotLoadReportData": "報表數據載入失敗",
  "reportDashboard.viewFiltersHaveChangedPreparingNewResultsOrWaitingForACompletePeriodPreviousResultsAreStillShown":
    "篩選範圍已更改，正在準備新結果或等待完整週期；目前顯示上次查詢結果。",
  "reportDashboard.viewLiveStatisticsUseCompletedOrderJSONDataLegacyExcelWorksheetsAreLoadedOnlyForCheckingNotForSalesTotalsRankingsOrTrendsCNYBusinessRemainsUnclassifiedTaxIsNotInferred":
    "實際看板採用成功訂單JSON統計；舊Excel工作表僅按需要讀取核對，不參與本頁銷售額、排名及趨勢。人民幣暫列待分類，不推算稅額。",
  "reportDashboard.viewFilters": "篩選條件",
  "reportDashboard.viewFilterTheDashboardByTimeValue0AndValue1Model":
    "按時間、{value0}及{value1}型號聯動查看看板",
  "reportDashboard.viewClearFilters": "清除篩選",
  "reportDashboard.viewDateRange": "時間範圍",
  "reportDashboard.viewSelectPeriod": "選擇週期",
  "reportDashboard.viewSelectAPeriod": "請選擇週期",
  "reportDashboard.viewCustomDates": "自訂日期",
  "reportDashboard.viewTo": "至",
  "reportDashboard.viewStartDate": "開始日期",
  "reportDashboard.viewEndDate": "結束日期",
  "reportDashboard.viewValue0Model": "{value0}型號",
  "reportDashboard.viewQuantityChartUnit": "數量圖表單位",
  "reportDashboard.viewCurrentScopeValue0": "目前範圍：{value0}",
  "reportDashboard.viewShareDenominatorTotalValue1ForValue0TheSameBusinessSourceAndCurrency":
    "佔比分母固定為{value0}、相同業務來源及貨幣的總{value1}",
  "reportDashboard.viewTheDenominatorDoesNotNarrowWithValue0OrModelSelectionCNYAndUSDAreCalculatedSeparately":
    "分母不隨{value0}或型號選擇收窄，人民幣與美元分開計算",
  "reportDashboard.viewNoAmountDataForThisDateRange":
    "目前時間範圍暫無金額數據",
  "reportDashboard.viewBusinessTrendsAndComposition": "業務趨勢與構成",
  "reportDashboard.viewViewValue0QuantityChangesAndCompositionByBusinessSource":
    "查看{value0}數量變化及不同業務來源的數量結構",
  "reportDashboard.viewValue0QuantityTrend": "{value0}數量趨勢",
  "reportDashboard.viewValidDetailQuantitiesGroupedByValue0Month":
    "按{value0}月份匯總有效明細數量",
  "reportDashboard.viewValue0UnitValue1": "{value0}單位：{value1}",
  "reportDashboard.viewALogarithmicScaleIsUsedForLargeMonthlyDifferencesLabelsShowActualQuantities":
    "月份差異較大，已使用對數刻度，數值標籤仍為實際數量",
  "reportDashboard.viewNoTrendData": "暫無趨勢數據",
  "reportDashboard.viewQuantityByBusinessSource": "數量業務構成",
  "reportDashboard.viewValue0QuantityShareByBusinessSource":
    "各類業務{value0}數量佔比",
  "reportDashboard.viewTotalValue0": "{value0}總量",
  "reportDashboard.viewAmountAnalysisAndValue0Ranking":
    "金額分析及{value0}排名",
  "reportDashboard.viewValue0CompositionAndTopValue1InTheOriginalCurrency":
    "按原有貨幣顯示{value0}構成及主要{value1}",
  "reportDashboard.viewBusinessValue0": "業務{value0}",
  "reportDashboard.viewSameCurrencyComparisonNoExchangeRateConversion":
    "以相同貨幣比較，未作匯率換算",
  "reportDashboard.viewValue0RecordsValue1Value2":
    "{value0} 筆 · {value1} {value2}",
  "reportDashboard.viewRankedInTheSelectedCurrencyUsingOriginalAmounts":
    "按所選貨幣排名，保留原有金額口徑",
  "reportDashboard.viewModelsAndDataCompleteness": "型號及數據完整性",
  "reportDashboard.viewModelPopularityAndCoverageOfKeyBusinessFields":
    "補充型號熱度及關鍵業務欄位覆蓋情況",
  "reportDashboard.viewTop6Value0Models": "{value0}型號 TOP 6",
  "reportDashboard.viewTop5Value0Models": "{value0}型號 TOP 5",
  "reportDashboard.viewModelPopularityByValue0Quantity":
    "按{value0}數量匯總型號熱度",
  "reportDashboard.viewPaidRecords": "已收款明細",
  "reportDashboard.viewValue0Records": "{value0} 筆",
  "reportDashboard.viewInvoicedRecords": "已開票明細",
  "reportDashboard.viewRecordsAwaitingPayment": "待收款明細",
  "reportDashboard.viewCustomerOrderProvided": "已填客戶訂單",
  "reportDashboard.viewShipmentDetailsProvided": "已填出貨資料",
  "reportDashboard.viewReceivingBankProvided": "已填收款銀行",
  "reportDashboard.viewPurchaseCostIncludingTax": "含稅採購成本",
  "reportDashboard.viewPurchaseCostExcludingTax": "未稅採購成本",
  "reportDashboard.viewTaxDifference": "稅額差異",
  "reportDashboard.viewPaymentDetailsProvided": "已填付款資料",
  "reportDashboard.viewWarehouseReceiptProvided": "已填入倉單號",
  "reportDashboard.viewInputInvoiceDateProvided": "已填進項發票日期",
  "reportDashboard.viewCompleteValue0Details": "{value0}完整明細",
  "reportDashboard.viewShowingValue0Value1Records":
    "目前顯示 {value0} / {value1} 筆",
  "reportDashboard.viewSearchSupplierModelOrderNo": "搜尋供應商、型號、訂單號…",
  "reportDashboard.viewDateAndBusinessSourceArePinnedScrollHorizontallyForMoreFieldsSelectARowForFullDetails":
    "日期及業務來源已固定，左右捲動查看更多欄位；按列查看完整資料",
  "reportDashboard.viewBusinessSource": "業務來源",
  "reportDashboard.viewNo": "序號",
  "reportDashboard.viewGoodsName": "貨物名稱",
  "reportDashboard.viewQuantity": "數量",
  "reportDashboard.viewUnitPrice": "單價",
  "reportDashboard.viewSalesAmount": "銷售金額",
  "reportDashboard.viewTotalAmount": "總金額",
  "reportDashboard.viewBusinessType": "業務類型",
  "reportDashboard.viewSalesperson": "業務員",
  "reportDashboard.viewReceivingBank": "收款銀行",
  "reportDashboard.viewPaymentMode": "付款模式",
  "reportDashboard.viewCustomerOrderNo": "客戶訂單號",
  "reportDashboard.viewShipmentTimeMethod": "出貨時間／方式",
  "reportDashboard.viewRemarks": "備註",
  "reportDashboard.viewActions": "操作",
  "reportDashboard.viewView": "查看",
  "reportDashboard.viewBusinessRecords": "業務記錄",
  "reportDashboard.viewViewOriginalShipmentReturnAndBusinessConfigurationRecords":
    "集中查看出貨、退貨及業務設定原始記錄",
  "reportDashboard.viewAddShipmentReturn": "新增出貨／退貨",
  "reportDashboard.viewAddConfiguration": "新增設定",
  "reportDashboard.viewShipmentReturnRecords": "出貨／退貨記錄",
  "reportDashboard.viewQuantityAwaitingReturn": "待退貨數量",
  "reportDashboard.viewValue0Pcs": "{value0} 件",
  "reportDashboard.viewRecordsToCheck": "待核對記錄",
  "reportDashboard.viewValue0Items": "{value0} 項",
  "reportDashboard.viewBusinessConfiguration": "業務設定",
  "reportDashboard.viewFromSheet4ReferenceQuantityPackagingDetailsRemarksAndStatus":
    "來自Sheet4，完整顯示單號、數量、包裝說明、備註及狀態",
  "reportDashboard.viewHReferenceAdjustment": "H單號／調整項",
  "reportDashboard.viewPackagingDetails": "包裝明細",
  "reportDashboard.viewStatus": "狀態",
  "reportDashboard.viewPackagingCheck": "包裝核對",
  "reportDashboard.viewDifferenceValue0Pcs": "相差 {value0} 件",
  "reportDashboard.viewMatched": "一致",
  "reportDashboard.viewBusinessConfigurationRecords": "業務設定記錄",
  "reportDashboard.viewFromSheet1BusinessTypeSalespersonAndPaymentModeFromTheSameSourceRow":
    "來自Sheet1，按原表同列顯示業務類型、業務員及付款模式",
  "reportDashboard.viewValue0RecordsInTotal": "共 {value0} 筆",
  "reportDashboard.viewSourceRowNo": "原表列號",
  "reportDashboard.viewNoConfiguration": "暫無設定",
  "reportDashboard.viewConfigurationFollowsSourceRowsEmptyCellsRemainEmptyValuesAreNotShiftedToFillGaps":
    "業務設定按原表同列對應；空白儲存格保留空白，不作錯位補齊。",
  "reportDashboard.viewSourceWorksheets": "原始工作表",
  "reportDashboard.viewAllExcelWorksheetsAreRetainedForSourceVerification":
    "保留Excel所有工作表內容，方便核對來源",
  "reportDashboard.viewSourceValue0RowsValue1ColumnsHeaderDetectedAtRowValue2":
    "原表 {value0} 列 × {value1} 欄 · 已識別第 {value2} 列為表頭",
  "reportDashboard.viewSemanticHeadersScrollHorizontallyToViewAllValue0Columns":
    "表頭已作語義化處理，左右捲動可查看工作表全部 {value0} 欄",
  "reportDashboard.viewEdit": "編輯",
  "reportDashboard.viewThisWorksheetIsEmpty": "目前工作表為空白",
  "reportDashboard.viewParsingComplete": "解析完成",
  "reportDashboard.viewWorksheet": "工作表",
  "reportDashboard.viewValue0Details": "{value0}明細",
  "reportDashboard.viewItemsToCheck": "待核對項目",
  "reportDashboard.viewImportMode": "匯入方式",
  "reportDashboard.viewReplaceCurrentData": "覆寫目前數據",
  "reportDashboard.viewAppendAndDeduplicate": "追加並去除重複",
  "reportDashboard.viewValue0RowValue1": "{value0} 第{value1}列",
  "reportDashboard.viewCancel": "取消",
  "reportDashboard.viewConfirmImport": "確認匯入",
  "reportDashboard.viewAddReportData": "新增報表數據",
  "reportDashboard.viewShipmentReturn": "出貨／退貨",
  "reportDashboard.viewBasicInformation": "基本資料",
  "reportDashboard.viewEnterQuantity": "請輸入數量",
  "reportDashboard.viewEnterUnitPrice": "請輸入單價",
  "reportDashboard.viewOptional": "可留空白",
  "reportDashboard.viewIfEmptyCalculateQuantityUnitPrice":
    "留空時按數量 × 單價計算",
  "reportDashboard.viewBusinessInformation": "業務資料",
  "reportDashboard.viewSettlementAndRemarks": "結算及備註",
  "reportDashboard.viewShipmentAndReturnDetails": "出貨及退貨資料",
  "reportDashboard.viewRecordStatus": "記錄狀態",
  "reportDashboard.viewNormal": "正常",
  "reportDashboard.viewAwaitingReturn": "待退貨",
  "reportDashboard.viewShipmentReduction": "減出貨",
  "reportDashboard.viewForExample15004Packs": "例如：1500*4包",
  "reportDashboard.viewForExampleFundedPurchasing": "例如：墊資代採",
  "reportDashboard.viewEnterSalesperson": "請輸入業務員",
  "reportDashboard.viewForExampleCollectionAndPaymentOnBehalf":
    "例如：代收代付",
  "reportDashboard.viewSaveAndRefreshDashboard": "儲存並重新整理看板",
  "reportDashboard.viewDetailsToCheck": "待核對詳情",
  "reportDashboard.viewValue0RowValue1Label": "{value0} · 第 {value1} 列",
  "reportDashboard.viewToBeConfirmed": "待確認",
  "reportDashboard.viewBusinessReference": "業務編號",
  "reportDashboard.viewEnteredValue": "填寫值",
  "reportDashboard.viewCalculatedValue": "計算值",
  "reportDashboard.viewDifference": "差異",
  "reportDashboard.viewReasonForChecking": "核對原因",
  "reportDashboard.viewCheckShipment": "前往出貨核對",
  "reportDashboard.viewEditSourceData": "編輯原始數據",
  "reportDashboard.viewWorksheetValue0": "工作表：{value0}",
  "reportDashboard.viewSourceRowValue0": "原表列號：{value0}",
  "reportDashboard.viewBusinessIdentifierValue0": "業務識別：{value0}",
  "reportDashboard.viewImportAndChangeHistory": "匯入及修改記錄",
  "reportDashboard.viewImportHistory": "匯入記錄",
  "reportDashboard.viewValue0Value1Records": "{value0} {value1} 筆",
  "reportDashboard.viewValue0Shipments": "出貨 {value0} 筆",
  "reportDashboard.viewValue0ItemsToCheckLabel": "待核對 {value0} 項",
  "reportDashboard.viewNoImportHistory": "暫無匯入記錄",
  "reportDashboard.viewChangeHistory": "修改記錄",
  "reportDashboard.viewDataChange": "數據修改",
  "reportDashboard.viewOperatorValue0": "操作人：{value0}",
  "reportDashboard.viewDataOwnerValue0": "數據歸屬：{value0}",
  "reportDashboard.viewNoChangeHistory": "暫無修改記錄",
  "reportDashboard.viewCNYUnclassified": "人民幣／待分類",
  "reportDashboard.viewCountedByCompletedOrderProductDetailRecordsNotContracts":
    "按交易完成訂單的商品明細記錄統計，不等同於合同數",
  "reportDashboard.viewDeduplicatedByCustomerSupplierIDEntitiesWithTheSameNameAreCountedSeparately":
    "按客戶／供應商主體ID去除重複，同名不同主體分開計數",
  "reportDashboard.viewDifferentQuantityUnitsAreNotAddedTogether":
    "不同數量單位不相加",
  "reportDashboard.viewAllTime": "全部時間",
  "reportDashboard.viewMonthly": "按月",
  "reportDashboard.viewQuarterly": "按季度",
  "reportDashboard.viewHalfYearly": "按半年",
  "reportDashboard.viewYearly": "按年",
  "reportDashboard.viewCustom": "自訂",
  "reportDashboard.viewCustomPeriod": "自訂時間",
  "reportDashboard.viewAllValue0": "全部{value0}",
  "reportDashboard.viewAllValue0Models": "全部{value0}型號",
  "reportDashboard.viewOneValue0OneModel": "單一{value0} + 單一型號",
  "reportDashboard.viewSelectValue0AndModel": "請選擇{value0}及型號",
  "reportDashboard.viewSelectValue0AndModelToView": "選擇{value0}及型號後查看",
  "reportDashboard.viewOneValue0": "單一{value0}",
  "reportDashboard.viewNoValue0Selected": "未選擇{value0}",
  "reportDashboard.viewSelectValue0ToView": "選擇{value0}後查看",
  "reportDashboard.viewOneProductModel": "單一產品型號",
  "reportDashboard.viewNoModelSelected": "未選擇型號",
  "reportDashboard.viewSelectAModelToView": "選擇型號後查看",
  "reportDashboard.viewValidValue0Details": "有效{value0}明細",
  "reportDashboard.viewBlankExcelRowsWithoutAValidQuantityOrAmountAreExcluded":
    "已排除Excel內沒有有效數量或金額的空白預留列",
  "reportDashboard.viewPartnerValue0": "合作{value0}",
  "reportDashboard.viewValue0Entities": "{value0} 家",
  "reportDashboard.viewDeduplicatedByValue0Name": "按{value0}名稱去除重複統計",
  "reportDashboard.viewTotalValue0Quantity": "{value0}總數量",
  "reportDashboard.viewTotalCNYSales": "人民幣銷售額合計",
  "reportDashboard.viewTotalCNYPurchaseCost": "人民幣採購成本合計",
  "reportDashboard.viewTotalUSDSales": "美元銷售額合計",
  "reportDashboard.viewTotalUSDPurchaseCost": "美元採購成本合計",
  "reportDashboard.viewCNYCashBusiness": "人民幣現金業務",
  "reportDashboard.viewCNYTaxInclusiveBusiness": "人民幣含稅業務",
  "reportDashboard.viewCNYCash": "人民幣現金",
  "reportDashboard.viewCNYTaxInclusive": "人民幣含稅",
  "reportDashboard.viewSales": "銷售",
  "reportDashboard.viewPurchasing": "採購",
  "reportDashboard.viewDate": "日期",
  "reportDashboard.viewModel": "型號",
  "reportDashboard.viewOrderDate": "訂單日期",
  "reportDashboard.viewOrderingCompany": "做單公司",
  "reportDashboard.viewSalesQuantity": "銷售數量",
  "reportDashboard.viewSalesUnitPrice": "銷售單價",
  "reportDashboard.viewSalesAmountExcludingTax": "未稅銷售金額",
  "reportDashboard.viewPaymentReceivedAt": "收款時間",
  "reportDashboard.viewInvoiceDate": "開票日期",
  "reportDashboard.viewWarehouseReceiptNo": "入倉號",
  "reportDashboard.viewPurchaseDate": "採購日期",
  "reportDashboard.viewSourceColumnC": "原表欄位C",
  "reportDashboard.viewOrderingAccount": "下單賬戶",
  "reportDashboard.viewOrderingAccountSourceColumnC": "下單賬戶／原表欄位C",
  "reportDashboard.viewPurchaseModel": "採購型號",
  "reportDashboard.viewPurchaseQuantity": "採購數量",
  "reportDashboard.viewPurchaseUnitPrice": "採購單價",
  "reportDashboard.viewCostExcludingTax": "未稅成本",
  "reportDashboard.viewPaymentTime": "付款時間",
  "reportDashboard.viewInputInvoiceDate": "進項發票日期",
  "reportDashboard.viewPurchaseWarehouseReceiptNo": "採購入倉單號",
  "reportDashboard.viewSalesShareAnalysis": "銷售佔比分析",
  "reportDashboard.viewPurchaseCostShareAnalysis": "採購成本佔比分析",
  "reportDashboard.viewPaymentAndInvoiceCoverage": "收款及開票覆蓋",
  "reportDashboard.viewTaxAndFieldCoverage": "稅額及欄位覆蓋",
  "reportDashboard.viewPaymentInvoiceAndCustomerOrderInformation":
    "同步顯示收款、開票及客戶訂單資料",
  "reportDashboard.viewTaxInclusiveBusinessCostsAndTextFieldCompleteness":
    "含稅業務成本及文字欄位完整性",
  "reportDashboard.viewLogScale": "對數刻度 · ",
  "reportDashboard.viewNotConnected": "待接入",
  "reportDashboard.viewTheSelectedCompanyIsOutsideTheAuthorizedOptions":
    "所選公司不在目前授權選項內",
  "reportDashboard.viewTheSelectedCustomerIsOutsideTheCurrentScope":
    "所選客戶不在目前範圍內",
  "reportDashboard.viewYourAccountDoesNotHavePermissionToViewReportData":
    "目前賬戶沒有報表數據查看權限",
  "reportDashboard.viewReportDataAccessHasNotBeenConfiguredForYourAccount":
    "目前賬戶尚未設定報表數據權限",
  "reportDashboard.viewJSONCompletedOrders": "JSON · 交易完成訂單",
  "reportDashboard.viewQueriedAtValue0": "查詢時間 {value0}",
  "reportDashboard.viewExportFailed": "匯出失敗",
  "reportDashboard.viewSelectACompanyBeforeLoadingLegacyWorksheetsForChecking":
    "請先選定公司，再按需要讀取舊工作表核對",
  "reportDashboard.viewLegacyReportVerification": "舊報表核對",
  "reportDashboard.viewCouldNotLoadLegacyWorksheetsForChecking":
    "舊工作表核對載入失敗",
  "reportDashboard.viewPurchaseAndSaleOnBehalf": "代採代銷",
  "reportDashboard.viewPurchasingWithAdvancePayment": "代採墊付",
  "reportDashboard.viewFactoringCredit": "保理放賬",
  "reportDashboard.viewReceivablesReport": "應收報表",
  "reportDashboard.viewSalesScaleCustomerCompositionPaymentsInvoicesAndSourceWorksheets":
    "統一查看銷售規模、客戶構成、收款開票及原始工作表",
  "reportDashboard.viewPayablesReport": "應付報表",
  "reportDashboard.viewPurchasingShipmentChecksBusinessDictionariesAndSourceWorksheets":
    "統一查看採購業務、出貨核對、業務字典及原始工作表",
  "reportDashboard.viewCalculatedPackagingQuantityDiffersFromTheEnteredQuantity":
    "包裝計算與填寫數量存在差異",
  "reportDashboard.viewAmountDiffersFromQuantityUnitPrice":
    "金額與數量 × 單價存在差異",
  "reportDashboard.viewOverview": "綜合看板",
  "reportDashboard.viewSourceData": "原始數據",
  "reportDashboard.viewYourAccountCanOnlyViewReports": "目前賬戶僅可查看報表",
  "reportDashboard.viewAllSalesModels": "全部銷售型號",
  "reportDashboard.viewAllPurchaseModels": "全部採購型號",
  "reportDashboard.viewTotalSalesQuantity": "銷售總數量",
  "reportDashboard.viewTotalPurchaseQuantity": "採購總數量",
  "reportDashboard.viewValue0NotProvided": "未標示{value0}",
  "reportDashboard.viewPackagingQuantityDiffersByValue0Pcs":
    "包裝計算與填寫數量相差 {value0} 件",
  "reportDashboard.viewDataUpdatedButThisBrowserCannotSaveItPersistently":
    "數據已更新，但目前瀏覽器無法持久儲存",
  "reportDashboard.viewThisWorksheetIsReadOnly": "目前工作表僅供唯讀查看",
  "reportDashboard.viewThisAccountOrWorksheetCannotBeEdited":
    "目前賬戶或工作表沒有編輯權限",
  "reportDashboard.viewNoChangesToSave": "沒有需要儲存的修改",
  "reportDashboard.viewSourceWorksheetNotFound": "原始工作表不存在",
  "reportDashboard.viewCurrentUser": "目前用戶",
  "reportDashboard.viewSourceDataUpdatedAndDashboardRecalculated":
    "原始數據已更新，看板已重新計算",
  "reportDashboard.viewCouldNotSave": "儲存失敗",
  "reportDashboard.viewOnlyXlsxOrXlsFilesAreSupported": "僅支援.xlsx或.xls檔案",
  "reportDashboard.viewCouldNotParseExcelCheckTheFileFormat":
    "Excel解析失敗，請檢查檔案格式",
  "reportDashboard.viewRestoreSourceFile": "還原來源檔案",
  "reportDashboard.viewCouldNotRestore": "還原失敗",
  "reportDashboard.viewUpdatedValue0": "{value0} 更新",
  "reportDashboard.viewCNY": "人民幣",
  "reportDashboard.viewUSD": "美元",
  "reportDashboard.viewUnnamedColumnValue0": "未命名欄 {value0}",
  "reportDashboard.readOnly": "唯讀",
  "reportDashboard.errorModelLimitExceeded": "型號範圍過大，請收窄篩選範圍",
  "reportDashboard.errorQuantityTrendLimitExceeded":
    "數量趨勢範圍過大，請收窄範圍",
  "reportDashboard.exportUnitPrice": "成交單價",
  "reportDashboard.exportSalesperson": "原報表業務員",
  "reportDashboard.exportContractNo": "合同編號（原客戶訂單欄）",
  "reportDashboard.exportPaymentConfirmedAt": "確認收款時間",
  "reportDashboard.exportInvoiceUploadedAt": "發票上載時間",
  "reportDashboard.exportShippedAt": "發貨時間",
  "reportDashboard.exportPaymentType": "付款業務類型編碼",
  "reportDashboard.exportSourceRemarks": "原合同／訂單備註",
  "reportDashboard.selectYear": "選擇年份",
  "reportDashboard.timeAxisUnit": "篩選單位",
  "reportDashboard.timeAxisDay": "天",
  "reportDashboard.timeAxisWeek": "週",
  "reportDashboard.timeAxisMonth": "月",
  "reportDashboard.timeAxisQuarter": "季",
  "reportDashboard.timeAxisYear": "年",
  "reportDashboard.timeAxisDailyUnavailable":
    "目前服務未提供日級趨勢，請更新 MTS API 後查看日／週／季／年趨勢",
  "reportDashboard.categoryTopSix": "分類產品 TOP 6",
  "reportDashboard.categoryTopFive": "分類產品 TOP 5",
  "reportDashboard.rankPrevious": "上一組",
  "reportDashboard.rankNext": "下一組",
  "reportDashboard.categoryDescription":
    "按目前篩選範圍、同單位數量排行；比例以該分類全部料號為分母",
  "reportDashboard.categoryWAFER": "WAFER",
  "reportDashboard.categoryFLASH": "FLASH顆粒",
  "reportDashboard.categoryDDR": "DDR顆粒",
  "reportDashboard.categorySSD": "SSD",
  "reportDashboard.categoryMEMORYMODULE": "記憶體模組",
  "reportDashboard.categoryUnit": "數量單位",
  "reportDashboard.businessSupplyChain": "供應鏈訂單",
  "reportDashboard.businessTrade": "貿易訂單",
  "reportDashboard.businessUnclassified": "待分類",
  "reportDashboard.categoryUnconverted":
    "有 {count} 條記錄使用包裝或未識別單位，缺少換算依據，未計入分類數量排行。",
  "reportDashboard.categoryLoading": "正在讀取分類排行…",
  "reportDashboard.categoryReadFailed": "分類讀取失敗，請重試",
  "reportDashboard.categoryEmpty": "目前篩選範圍內，該類型沒有交易完成的訂單",
  "reportDashboard.categoryRetry": "重試",
  "reportDashboard.categoryAwaitingQuery": "等待目前篩選查詢完成",
  "reportDashboard.categoryUnknownQuantity":
    "存在數量缺漏，比例不可作為完整業務佔比",
  "reportDashboard.quantityChartLabel": "{value0}數量趨勢圖",
  "reportDashboard.businessDate": "{value0}日期",
  "reportDashboard.packagingDifferencesHint":
    "發現 {value0} 筆包裝數量差異，請在出貨／退貨記錄的「包裝核對」欄核對。",
  "reportDashboard.paid": "已收款",
  "reportDashboard.shipmentRecords": "出貨記錄",
  "reportDashboard.importDifferencesHint":
    "發現 {value0} 項差異，匯入後會保留並提示。",
  "reportDashboard.businessLabel": "{value0}業務",
  "reportDashboard.businessQuantity": "{value0}數量",
  "reportDashboard.businessUnitPrice": "{value0}單價",
  "reportDashboard.businessFullRecord": "{value0}記錄完整資料",
  "reportDashboard.validationDifferencesHint":
    "發現 {value0} 項數據差異，請參照原始工作表確認。",
  "reportDashboard.shipmentQuantityCheck": "出貨數量核對",
  "reportDashboard.valueCheck": "{value0}核對",
  "reportDashboard.enterField": "請輸入{value0}",
  "reportDashboard.dateRangeText": "{value0} 至 {value1}",
  "reportDashboard.errorUnitLimitExceeded": "數量單位範圍過大，請收窄篩選範圍",
  "reportDashboard.unitSinglePiece": "片",
  "reportDashboard.salesCompany": "銷售公司",
  "reportDashboard.orderingCompany": "下單公司",
  "reportDashboard.allSalesCompanies": "全部銷售公司",
  "reportDashboard.allOrderingCompanies": "全部下單公司",
  "reportDashboard.receivablesTemplateFilename": "應收業務數據匯入範本.xlsx",
  "reportDashboard.payablesTemplateFilename": "應付業務數據匯入範本.xlsx",
  "reportDashboard.receivablesExportFilename": "應收業務數據_{date}.xlsx",
  "reportDashboard.payablesExportFilename": "應付業務數據_{date}.xlsx",
  "reportDashboard.errorCategoryInvalid": "產品分類無效",
  "reportDashboard.businessFactsTitle": "真實訂單業務記錄",
  "reportDashboard.businessLegacyDeferred":
    "原工作表業務記錄尚未讀取，可按需使用上方核對入口；未讀取不代表出貨、退貨數量為零。",
  "reportDashboard.businessFactsScope":
    "按訂單建立日期及主看板相同範圍讀取；以下狀態編碼及業務事實來自訂單，並非原始工作表配置",
  "reportDashboard.businessFactsCompany": "本方公司",
  "reportDashboard.businessFactsModel": "料號",
  "reportDashboard.businessFactsSalesperson": "原報表業務員",
  "reportDashboard.businessFactsShipStatus": "發貨狀態編碼",
  "reportDashboard.businessFactsCarrier": "物流公司",
  "reportDashboard.businessFactsTracking": "物流單號",
  "reportDashboard.businessFactsUnavailable":
    "實際出貨數量、退貨、入倉號、客戶PO及貿易／供應鏈分類尚未具備可靠訂單歸屬，不以訂單數量或固定值代填。下方原工作表記錄僅供核對。",
  "reportDashboard.categoryResponseInvalid": "分類排名回傳格式錯誤",
});

export const messages = Object.freeze({ ...flows, ...reportDashboard });
